import { render, staticRenderFns } from "./StartPost.vue?vue&type=template&id=629c69d2&"
import script from "./StartPost.vue?vue&type=script&lang=js&"
export * from "./StartPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports